module.exports = __webpack_public_path__ + "static/media/heart.da1a1de0.png";